import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccountPageWrapper } from "../../../Shared/components/PageWrapper/AccountPageWrapper";
import { Prompt } from "../../../Shared/components/Prompt";
import { AccountPageTitle } from "../../utils/Page";
import { useOpenBalanceContext } from "../context/OpenBalanceContext";
import { OpenBalanceTexts } from "../utils/openBalance-enums";
import { ComponentSwitcher } from "./ComponentSwticher";
export const OpenBalancePageContent = () => {
    const OBP = useOpenBalanceContext();
    return (_jsxs(AccountPageWrapper, Object.assign({ id: "open-balance-page" }, { children: [_jsx(AccountPageTitle, { title: OpenBalanceTexts.PAGE_TITLE }), _jsx(Prompt, { when: OBP.shouldPromptBeforeNavigation, optionalMessage: OpenBalanceTexts.NAVIGATION_PROMPT_MESSAGE }), _jsx(ComponentSwitcher, {})] })));
};
